import { Directive, input } from '@angular/core';
import { InputText } from 'primeng/inputtext';

@Directive({
    selector: '[fcpInputText]',
    standalone: true,
    host: {
        '[attr.data-e2e-hook]': 'e2e()',
        '[id]': 'id()'
    },
    hostDirectives: [
        {
            directive: InputText,
            inputs: ['pSize: size', 'fluid']
        }
    ]
})
export class FcpInputTextDirective {
    e2e = input<string | null>(null);
    size = input<FcpInputTextSize>(FcpInputTextSize.Normal);
    fluid = input<boolean>(false);
    id = input<string>();
}

export enum FcpInputTextSize {
    Small = 'small',
    Normal = null
}
